import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  background-color: ${({ theme }) => theme.neutral.white};
`;
